import styled from "styled-components";

export const ContentHolder = styled.div`
    width: 100%;
    max-width: 1400px;
    padding: 1rem;

    @media print {
        padding: 0 1rem;
    }
`;
